import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "O Ataric é para qual nível de inglês?",
      answer: "O Ataric é para todos os níveis! Se você é iniciante, a IA vai te guiar em conversas simples e ir evoluindo com você. Se já tem um nível intermediário ou avançado, vai ter conversas mais desafiadoras para aperfeiçoar sua fluência.",
    },
    {
      question: "Preciso de muito tempo por dia?",
      answer: "Não! Com apenas 10-15 minutos por dia você já consegue ver resultados. O importante é a consistência. A IA está disponível 24/7, então você pratica quando e onde quiser.",
    },
    {
      question: "Como funciona a garantia de 7 dias?",
      answer: "É simples: você testa o Ataric por 7 dias. Se não gostar ou não sentir que está evoluindo, é só pedir o reembolso e devolvemos 100% do seu dinheiro. Sem perguntas, sem burocracia.",
    },
    {
      question: "Posso usar no celular?",
      answer: "Sim! O Ataric funciona perfeitamente no celular, tablet e computador. Você pode praticar no caminho do trabalho, na hora do almoço ou antes de dormir.",
    },
    {
      question: "A IA realmente conversa comigo por voz?",
      answer: "Sim! Você fala por voz e a IA responde por voz também. É como uma conversa real, mas sem a vergonha de errar na frente de outras pessoas. A IA te corrige e te ajuda a melhorar em tempo real.",
    },
    {
      question: "O que torna o Ataric diferente de outros apps?",
      answer: "A maioria dos apps te faz ler, ouvir ou responder exercícios escritos. O Ataric te faz FALAR. Você pratica conversação de verdade, com uma IA que entende o que você fala, corrige seus erros e te ajuda a evoluir.",
    },
    {
      question: "Posso cancelar a qualquer momento?",
      answer: "Sim! Você pode cancelar sua assinatura quando quiser, sem taxas ou burocracias. Mas acreditamos tanto no Ataric que dificilmente você vai querer cancelar depois de ver os resultados.",
    },
  ];

  return (
    <section id="faq" className="py-20 md:py-32 relative overflow-hidden">
      <div className="absolute inset-0 hero-gradient" />
      
      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-6">
            Perguntas{" "}
            <span className="text-gradient">frequentes</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Tire suas dúvidas sobre o Ataric.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="card-glass rounded-xl border-none px-6"
              >
                <AccordionTrigger className="text-left font-display text-lg font-semibold text-foreground hover:text-primary transition-colors py-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQ;
